export function formatDate(dateString: string): string {
  return new Date(dateString).toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
}

const FULL_DATE_TIME_FORMAT = new Intl.DateTimeFormat(undefined, {
  year: "numeric",
  month: "short",
  day: "numeric",
  hour: "2-digit",
  minute: "2-digit",
});

const RELATIVE_TIME_FORMAT = new Intl.RelativeTimeFormat(undefined, { numeric: "auto" });

const RELATIVE_RANGES: Array<[Intl.RelativeTimeFormatUnit, number]> = [
  ["year", 60 * 60 * 24 * 365],
  ["month", 60 * 60 * 24 * 30],
  ["week", 60 * 60 * 24 * 7],
  ["day", 60 * 60 * 24],
  ["hour", 60 * 60],
  ["minute", 60],
];

export function formatFullDateTime(dateString: string): string {
  return FULL_DATE_TIME_FORMAT.format(new Date(dateString));
}

export function formatRelativeTime(dateString: string): string {
  const seconds = Math.round((new Date(dateString).getTime() - Date.now()) / 1000);
  for (const [unit, secondsPerUnit] of RELATIVE_RANGES) {
    if (Math.abs(seconds) >= secondsPerUnit) {
      return RELATIVE_TIME_FORMAT.format(Math.round(seconds / secondsPerUnit), unit);
    }
  }
  return RELATIVE_TIME_FORMAT.format(seconds, "second");
}
